import React from 'react';
import Layout from '../Layout/index';
import FarmItem from '../Dashboard/FarmItem';

export default function Dashboard() {
  return (
    <Layout>
      <div id="appDashBoard">
        <FarmItem />
      </div>
    </Layout>
  );
}
